import { ReactNode } from "react";
import { Settings } from "lucide-react";
import { Button } from "~/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "~/components/ui/dropdown-menu";

interface SettingsMenuProps {
  children: ReactNode;
  label?: string;
}

/**
 * Gear menu that lives at the far right of the entity header bar (project /
 * dataset / agent). Each entity passes its own DropdownMenu items as children.
 */
export function SettingsMenu({ children, label = "Settings" }: SettingsMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          aria-label={label}
          className="size-8 text-muted-foreground"
        >
          <Settings className="size-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        {children}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
